import {
  heroArrowLeft,
  heroCog6Tooth,
  heroArrowsRightLeft,
  heroArrowRightStartOnRectangle,
  heroArrowUturnLeft,
  heroBeaker,
  heroBell,
  heroCalendar,
  heroCheckCircle,
  heroChevronRight,
  heroCpuChip,
  heroCube,
  heroExclamationTriangle,
  heroIdentification,
  heroInformationCircle,
  heroLifebuoy,
  heroMagnifyingGlass,
  heroMapPin,
  heroPencilSquare,
  heroPlus,
  heroPlusCircle,
  heroQuestionMarkCircle,
  heroSignal,
  heroTrash,
  heroTruck,
  heroUser,
  heroUserGroup,
  heroUsers,
  heroWrench,
  heroWrenchScrewdriver,
  heroXMark
} from '@ng-icons/heroicons/outline';

/**
 * Icons available to <ng-icon name="..."> and df components (Heroicons outline, as in the df design system).
 */
export const APP_ICONS = {
  heroArrowLeft,
  heroCog6Tooth,
  heroArrowsRightLeft,
  heroArrowRightStartOnRectangle,
  heroArrowUturnLeft,
  heroBeaker,
  heroBell,
  heroCalendar,
  heroCheckCircle,
  heroChevronRight,
  heroCpuChip,
  heroCube,
  heroExclamationTriangle,
  heroIdentification,
  heroInformationCircle,
  heroLifebuoy,
  heroMagnifyingGlass,
  heroMapPin,
  heroPencilSquare,
  heroPlus,
  heroPlusCircle,
  heroQuestionMarkCircle,
  heroSignal,
  heroTrash,
  heroTruck,
  heroUser,
  heroUserGroup,
  heroUsers,
  heroWrench,
  heroWrenchScrewdriver,
  heroXMark
};
